// The drop down button for a drop down menu.
// @flow
import React, { PureComponent } from 'react';
import { Button } from 'material-ui';
import ArrowDropIcon from '@material-ui/icons/ArrowDropDown';

import GroupIcon from '../GroupIcon';

type Props = {
    onClick: () => void,
    icon: string,
    title: string
};

export default class DropDownButton extends PureComponent<Props> {
    render() {
        const { onClick, icon, title } = this.props;

        return (
            <div className="nav-title-button">
                <Button onClick={onClick} className="nav-toolbar-button">
                    {icon ? <GroupIcon src={icon} /> : null}
                    <h3>{title}</h3>
                    <ArrowDropIcon />
                </Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/common/dropdown/DropDownButton.jsx